import { Injectable } from '@angular/core';
import { DeploymentFrequency } from '@models/DF/df';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetDF } from '@stores/df/df.actions';

interface DFStateModel {
  deploymentFrequency: DeploymentFrequency;
}

@State<DFStateModel>({
  name: 'df',
  defaults: undefined,
})
@Injectable()
export class DFState {
  @Selector()
  static deploymentFrequency(state: DFStateModel): DeploymentFrequency | undefined {
    return state.deploymentFrequency;
  }

  @Action(SetDF)
  setDF({ setState }: StateContext<DFStateModel>, { deploymentFrequency }: SetDF): void {
    setState({ deploymentFrequency: deploymentFrequency });
  }
}
